<template>
    <div class="journey-metadata">
      <span class="time-to-complete" v-if="duration">
        {{ $t('message.recommended-time-to-complete') }}: {{monthText}} {{weekText}}
      </span>
    </div>
</template>

<script>
  const AVG_WEEKS_IN_MONTH = 4;
  const DAYS_IN_WEEK = 7;

  export default {
    props: {
      'duration': {
        type: Number
      }, 
      "includeTasks": {
        type: Boolean,
        default: false
      }
    },
    computed: {
      durationWeeks() {
        return Math.floor(this.duration / DAYS_IN_WEEK);
      },
      monthsToGo(){
        return Math.floor(this.durationWeeks / AVG_WEEKS_IN_MONTH);
      },
      weeksToGo(){
        return this.durationWeeks % AVG_WEEKS_IN_MONTH;
      },
      monthText() {
        if (this.monthsToGo) {
          return `${this.$tc('message.month-plurlz', this.monthsToGo)}`
        }
        return '';
      },
      weekText() {
        if (this.weeksToGo) {
          return `${this.$tc('message.week-plurlz', this.weeksToGo)}`;
        } else if (this.duration < 7) {
          return `${this.$tc('message.day-plurlz', this.daysToGo)}`;
        }
        return '';
      }
    },
  }
</script>